module.exports = __webpack_public_path__ + "static/media/logo_secondary.9717af61.png";